import React, {
    ReactNode, useState,
} from "react";

import classNames from "classnames";

import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { RiArrowDownSLine } from "@remixicon/react";
import Dropdown from "../../theme/dropdown/Dropdown";
import DateCalendarPicker from "./DateCalendarPicker";
import Styles from "./DateRangeCalendarPicker.module.scss";
import { tryParseDate } from "../../../date";

export interface DateCalendarFilterPickerProps {
    value: Date | string | undefined | null;
    className?: string;
    calendarClassName?: string;
    onChange: (value: Date | undefined) => void;
    icon?: ReactNode;
    toggleText?: string;
    allowTime?: boolean;
    allowNewTime?: boolean;
    isActive?: boolean
    shouldPortal?: boolean;
}

export default function DateCalendarFilterPicker(props: DateCalendarFilterPickerProps): ReactNode {
    const { value } = props;
    const [isVisible, setIsVisible] = useState(false);
    const parsed = tryParseDate(value);
    return (
        <Dropdown
            show={isVisible}
            className={classNames(Styles["filter-picker"], props.className)}
            onToggle={nextValue => setIsVisible(nextValue)}
        >
            <Dropdown.Toggle
                variant="filter"
                prefixIcon={props.icon}
                postfixIcon={<RiArrowDownSLine />}
                isActive={props.isActive}
            >
                <div className="w-100 d-inline">

                    {props.toggleText && (
                        <>
                            {props.toggleText}
                            :
                            {" "}
                        </>
                    )}
                    {props.allowTime ? parsed?.toLocaleString() : parsed?.toLocaleDateString()}
                </div>

            </Dropdown.Toggle>
            <DateCalendarPicker
                shouldMenu
                calendarClassName={props.calendarClassName}
                {...props}
                shouldPortal={props.shouldPortal}
                allowNewTime={props.allowNewTime}
                onChange={changed => {
                    setIsVisible(false);
                    props.onChange(changed);
                }}
            />
        </Dropdown>

    );
}

DateCalendarFilterPicker.defaultProps = {

    className: "text-light-400 p-0 me-3",
    icon: undefined,
    toggleText: undefined,
    allowTime: false,
    allowNewTime: false,
    isActive: false,
    shouldPortal: false,
    calendarClassName: undefined,
};
